import { clientProfileApi } from "../../api";

const ClientProfileDropdownService = {
  /**
   * 🔽 Obtiene la lista de perfiles de cliente disponibles para el dropdown.
   */
  fetchDropdown: async () => {
    const response = await clientProfileApi.fetchCustom("/dropdown");
    return response.data;
  },
};

export default ClientProfileDropdownService;
